import React, { useState } from "react";

export const useDPIScreenCheck = () => {
  const [isHighDPI] = useState(() =>
    typeof window !== "undefined" ? window.devicePixelRatio > 1 : false
  );
  return isHighDPI;
};